/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/components/WorkflowStepDrawer.jsx
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Workflow Step
 *
 * PURPOSE:
 * Workflow Step Create / Edit Dialog
 *
 * ARCHITECTURE
 * - Bootstrap/AdminLTE
 * - Stateless Component
 * - Hosts WorkflowStepForm
 * - No Business Logic
 ******************************************************************************/

import React from "react";

import WorkflowStepForm from "./WorkflowStepForm";

export default function WorkflowStepDrawer({

    open,

    mode = "create",

    workflowStep = null,

    formData,

    errors = {},

    loading = false,

    saving = false,

    approvalLevels = [],

    rejectActions = [],

    onChange,

    onSubmit,

    onClose,

}) {

    if (!open) {

        return null;

    }

    const title =
        mode === "edit"
            ? "Edit Workflow Step"
            : "Add Workflow Step";

    return (

        <div
            className="modal fade show"
            style={{
                display: "block",
                backgroundColor: "rgba(0,0,0,0.50)",
            }}
        >

            <div className="modal-dialog modal-xl modal-dialog-scrollable">

                <div className="modal-content">

                    {/* ------------------------------------------------ */}
                    {/* Header */}
                    {/* ------------------------------------------------ */}

                    <div className="modal-header">

                        <h5 className="modal-title">

                            {title}

                        </h5>

                        <button

                            type="button"

                            className="btn-close"

                            onClick={onClose}

                        />

                    </div>

                    {/* ------------------------------------------------ */}
                    {/* Body */}
                    {/* ------------------------------------------------ */}

                    <div className="modal-body">

                        <WorkflowStepForm

                            formData={formData}

                            errors={errors}

                            approvalLevels={approvalLevels}

                            rejectActions={rejectActions}

                            loading={loading}

                            saving={saving}

                            onChange={onChange}

                            onSubmit={onSubmit}

                            onCancel={onClose}

                        />

                    </div>

                </div>

            </div>

        </div>

    );

}